     
<div class="question-container">
    <label [innerHTML]="label" [class.required]="isRequired && label" ></label>
 
  <mat-form-field appearance="outline" class="full-width">
       
    <input matInput [formControl]="control" [placeholder]="placeholder" [type]="passwordVisibility ? 'text' : 'password'" [autocomplete]="autocomplete"/>
    <button matSuffix mat-icon-button aria-label="Show Password" (click)="togglePasswordVisibility()">
        <mat-icon>{{ passwordVisibility ? 'visibility' : 'visibility_off'  }}</mat-icon>
    </button>
       @if (showError && errorMessages.length) {    
      <mat-error>
        @for (msg of errorMessages; track msg) {
          <span [innerHTML]="msg"></span>
        }
      </mat-error>
    }
  </mat-form-field>
</div>